// Puerto verbatim de packages/hce/src/hce/licenciaHce/modoConsulta.ts.
import type { MedplumClient } from '@medplum/core';

const EXT_LICENCIA_HCE = 'http://logiacare.ec/fhir/licencia-hce-estado';

export type EstadoLicenciaHce = {
  estado: 'vigente' | 'modo-consulta' | 'custodia' | 'borrado' | 'bloqueo';
  modoConsultaDesde?: string;
  custodiaHasta?: string;
};

const ESTADOS_VALIDOS = new Set(['vigente', 'modo-consulta', 'custodia', 'borrado', 'bloqueo']);

let estadoCache: EstadoLicenciaHce | undefined;

async function leerEstadoDesdeOrganization(medplum: MedplumClient): Promise<EstadoLicenciaHce> {
  try {
    const bundle = await medplum.search('Organization', {});
    const org = bundle.entry?.[0]?.resource;
    const ext = org?.extension?.find((e) => e.url === EXT_LICENCIA_HCE);
    const campo = (nombre: string) => ext?.extension?.find((e) => e.url === nombre);
    const estadoRaw = campo('estado')?.valueCode;
    return {
      estado: typeof estadoRaw === 'string' && ESTADOS_VALIDOS.has(estadoRaw) ? (estadoRaw as EstadoLicenciaHce['estado']) : 'vigente',
      modoConsultaDesde: campo('modo-consulta-desde')?.valueDateTime,
      custodiaHasta: campo('custodia-hasta')?.valueDate,
    };
  } catch {
    return { estado: 'vigente' };
  }
}

export async function obtenerEstadoLicenciaHce(medplum: MedplumClient | undefined): Promise<EstadoLicenciaHce> {
  if (estadoCache !== undefined) return estadoCache;
  if (!medplum) return { estado: 'vigente' };
  estadoCache = await leerEstadoDesdeOrganization(medplum);
  return estadoCache;
}

export function _resetEstadoLicenciaHceCacheForTests(): void {
  estadoCache = undefined;
}

export function esSoloLectura(estado: EstadoLicenciaHce): boolean {
  return estado.estado !== 'vigente';
}
